import React from 'react';

const POS_NEG = ({ posText, negText }) => {

    return (
        <span>
            <center><h2>Most Positive and Negetive Reviews</h2></center>
        <hr className="line"/>
            <p className="mt-30 red">
               " {negText} "
            </p> <br />
            <p className="mt-30 green">
               " {posText} "
            </p>
        </span>
    )


}

export default POS_NEG;